__turbopack_context__.v({
  "addToCalendar": "calendar-alerts-module-scss-module__o7t02a__addToCalendar",
  "body": "calendar-alerts-module-scss-module__o7t02a__body",
  "cal": "calendar-alerts-module-scss-module__o7t02a__cal",
  "event": "calendar-alerts-module-scss-module__o7t02a__event",
  "eventDate": "calendar-alerts-module-scss-module__o7t02a__eventDate",
  "eventDay": "calendar-alerts-module-scss-module__o7t02a__eventDay",
  "eventDayShort": "calendar-alerts-module-scss-module__o7t02a__eventDayShort",
  "eventMeta": "calendar-alerts-module-scss-module__o7t02a__eventMeta",
  "eventMonth": "calendar-alerts-module-scss-module__o7t02a__eventMonth",
  "eventTitle": "calendar-alerts-module-scss-module__o7t02a__eventTitle",
  "events": "calendar-alerts-module-scss-module__o7t02a__events",
  "eyebrow": "calendar-alerts-module-scss-module__o7t02a__eyebrow",
  "grid": "calendar-alerts-module-scss-module__o7t02a__grid",
  "heading": "calendar-alerts-module-scss-module__o7t02a__heading",
  "left": "calendar-alerts-module-scss-module__o7t02a__left",
  "right": "calendar-alerts-module-scss-module__o7t02a__right",
  "viewAll": "calendar-alerts-module-scss-module__o7t02a__viewAll",
  "wlink": "calendar-alerts-module-scss-module__o7t02a__wlink",
  "wlinks": "calendar-alerts-module-scss-module__o7t02a__wlinks",
});
